import React from 'react';

// Components
import Typography from '@components/UI-KIT/Typography';
import Divider from '@components/UI-KIT/Divider';
import Button from '@components/UI-KIT/Button';

// Material-ui
import { Grid } from '@material-ui/core';

// Icons
import { Edit, More } from '@/assets/icons';

// Styles
import VARIABLES from '@/assets/variables';
import './tableHead.scss';

interface Props {
    title: string;
    handleEdit?: () => void;
    inDrawer?: boolean;
    divider?: boolean;
    actionTitle?: string;
    add?: boolean;
}

const TableHead: React.FC<Props> = ({
    title,
    handleEdit,
    inDrawer = false,
    divider = false,
    actionTitle = 'Editar',
    add = false
}) => {
    return (
        <Grid
            className={`AOL-listings-table-head${inDrawer ? '' : '-profile'}`}
        >
            <Grid
                container
                justify="space-between"
                alignItems="center"
                wrap="nowrap"
            >
                <Typography
                    variant="h2"
                    color="secondary"
                >
                    {title}
                </Typography>
                { handleEdit && (
                    <Button
                        level={4}
                        icon={add ? (
                            <More
                                color={VARIABLES.palette.secondary_color}
                            />
                        ) : (
                            <Edit
                                color={VARIABLES.palette.secondary_color}
                            />
                        )}
                        label={actionTitle}
                        onClick={handleEdit}
                    />
                )}
            </Grid>
            { divider && (
                <Divider
                    className="AOL-listings-table-head-divider"
                />
            )}
        </Grid>
    );
};

export default TableHead;
